import create from 'zustand';

interface Store {
    query: string;
    isOverlayVisible: boolean;
}

interface Actions {
    setQuery(query: Store['query']): void;
    setIsOverlayVisible: (newState: Store['isOverlayVisible']) => void;
    resetOverlay: () => void;
}

export const useSearchOverlay = create<Store & Actions>((set) => ({
    query: '',
    setQuery: (query: Store['query']) => set({ query }),

    isOverlayVisible: false,
    setIsOverlayVisible: (newState: Store['isOverlayVisible']) =>
        set({ isOverlayVisible: newState }),

    resetOverlay: () => set({ query: '', isOverlayVisible: false }),
}));
